import { FC } from 'react';
import { SwitchDescriptive, SwitchDescriptiveNullable } from 'team-hero-ui';

import { ISwitchFieldProps } from './SwitchField.types';
import { SwitchFieldContainer } from './SwitchField.styled';

const SwitchField: FC<ISwitchFieldProps> = ({
  label,
  onChange,
  checked = null,
  hint,
  disabled = false,
  isNullable = false,
  styleType = 'modal',
}) => {
  return (
    <SwitchFieldContainer>
      {isNullable ? (
        <SwitchDescriptiveNullable
          value={checked}
          label={label}
          onChange={onChange}
          helperText={hint}
          disabled={disabled}
          styleType={styleType}
        />
      ) : (
        <SwitchDescriptive
          checked={!!checked}
          label={label}
          onChange={onChange}
          helperText={hint}
          styleType={styleType}
          disabled={disabled}
        />
      )}
    </SwitchFieldContainer>
  );
};

export default SwitchField;
